module.exports = __webpack_public_path__ + "static/Medusa-3e86c278b8a09f962b235caf4918b84b.jpg";